module.exports = __webpack_public_path__ + "static/media/moore.7f5b24fb.png";